import { formValueSelector, arrayRemove, arrayPush } from 'redux-form';
import { REDUX_FORM_CHANGE } from '@hbrisk/sp3-risk-model-support/actions/types.js';
import {
  BUILDING_TYPE_DIR_1,
  BUILDING_TYPE_DIR_2,
  STRUCTURAL_RESPONSES,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import { STRUCTURAL_RESPONSE_METHOD_VALUES } from '@hbrisk/sp3-risk-model-support/models/app/attributes/values/index.js';

import requiredEdpsForBuildingTypes from '#support/models/buildingType/requiredEdpsForBuildingTypes/index.js';
import { selectResponseItemKeysWithDefinedComponents } from '#selectors/ui/form/model.js';

const updateStructuralResponsesOnBuildingTypeChange = ({ store, action, form }) => {
  const { type } = action;
  if (type === REDUX_FORM_CHANGE) {
    const {
      meta: { field, form: actionForm },
    } = action;
    if (actionForm === form && [BUILDING_TYPE_DIR_1, BUILDING_TYPE_DIR_2].includes(field)) {
      const state = store.getState();
      const {
        [BUILDING_TYPE_DIR_1]: buildingTypeDir1,
        [BUILDING_TYPE_DIR_2]: buildingTypeDir2,
        [STRUCTURAL_RESPONSES]: structuralResponses,
      } = formValueSelector(form)(
        state,
        BUILDING_TYPE_DIR_1,
        BUILDING_TYPE_DIR_2,
        STRUCTURAL_RESPONSES
      );

      const requiredEdpKeys = requiredEdpsForBuildingTypes(buildingTypeDir1, buildingTypeDir2);

      const itemKeysWithComponents = selectResponseItemKeysWithDefinedComponents(actionForm)(state);

      const indexesToRemove = Array.isArray(structuralResponses)
        ? structuralResponses.reduceRight(
            (acc, response, index) =>
              response.method === STRUCTURAL_RESPONSE_METHOD_VALUES.SP3 &&
              !requiredEdpKeys.includes(response.edpKey) &&
              !itemKeysWithComponents.includes(response.edpKey)
                ? [...acc, index]
                : acc,
            []
          )
        : [];

      indexesToRemove.forEach(index => {
        store.dispatch(arrayRemove(form, STRUCTURAL_RESPONSES, index));
      });

      const missingEdpKeys = Array.isArray(structuralResponses)
        ? requiredEdpKeys.filter(
            key => !structuralResponses.some(response => response.edpKey === key)
          )
        : requiredEdpKeys;

      const itemsToAdd = missingEdpKeys.map(key => ({ edpKey: key }));
      itemsToAdd.forEach(itemAsValues => {
        store.dispatch(arrayPush(form, STRUCTURAL_RESPONSES, itemAsValues));
      });
    }
  }
};

export default updateStructuralResponsesOnBuildingTypeChange;
